<template>
  <svg
    :class="['svg-button', `svg-button--${name}`, `svg-button--${type}`]"
    :x="x"
    :y="y"
    width="28"
    height="28"
    viewBox="0 0 26 26"
  >
    <g class="svg-button__item">
      <phone v-if="['next'].includes(name) && ['call', 'queue'].includes(type)" />
      <timeout v-if="['timeout'].includes(name)" />
      <yes v-if="['yes'].includes(name)" />
      <no v-if="['no'].includes(name)" />
      <key-n v-if="is_number_key(name)" :name="name" />

      <remove v-if="type!=='start'" class="svg-button__item--remove" @click="remove" />
    </g>
  </svg>
</template>

<script>
  import Remove from './remove';
  import Phone from './phone';
  import Timeout from './timeout';
  import KeyN from './key-n';
  import Yes from './yes';
  import No from './no';

  export default {
    components: { Remove, Phone, Timeout, KeyN, Yes, No },
    props: {
      name: {
        type: String,
        default: ''
      },

      type: {
        type: String,
        default: ''
      },

      x: {
        type: [String, Number],
        default: 0
      },

      y: {
        type: [String, Number],
        default: 0
      }
    },

    methods: {
      remove: function() {
        this.$emit('remove', { name: this.name });
      },

      is_number_key: function(key) {
        return [
          'key_0',
          'key_1',
          'key_2',
          'key_3',
          'key_4',
          'key_5',
          'key_6',
          'key_7',
          'key_8',
          'key_9'
        ].includes(key);
      }
    }
  };
</script>

<style lang="scss">
  .svg-button {
    &__item {
      &--remove {
        display: none;
      }

      &:hover {
        .svg-button__item--remove {
          display: block !important;
        }
      }
    }
  }
</style>
